module.exports = __webpack_public_path__ + "static/forelli1-175b13bb100a161f99d93972047eaf81.png";